import { fromJS } from 'immutable'
import moment from 'moment'

export const collectionState = fromJS({
  by: 'date',
  date_from: moment(),
  date_to: moment(),
  or_from: '',
  or_to: '',
  fund: '',
  cashier_id: 0,
})

const initialState = fromJS({
  pending: false,
  data: {}, // header, data
})

export default function collection(state = initialState, action) {
  switch (action.type) {
    case 'COL_REQ':
      return state
        .set('pending', true)
        .set('data', fromJS({}))

    case 'COL_GET_SUCC':
      return state
        .set('pending', false)
        .set('data', fromJS(action.payload || {}))

    case 'NOTIF_FAIL':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/reducer.js